import React, { useEffect, useState } from "react";
import coinGecko from "../../assets/js/coinGecko";
import TRXChart from "./TRXChart";
import TRXContent from "./TRXContent";
import "./css/Valuation.css";

const Valuation = (props) => {
    let trxPercent;
    const [isLoading, setIsLoading] = useState(true)
    const [trxData, setTRXData] = useState([])
    const [currency, setCurrency] = useState(props.currency)

    useEffect(() => {

        const fetchcoinDetails = async () => {

            let trxPriceData

            setIsLoading(true)
            trxPriceData = await coinGecko.get("/coins/markets", {
                params: {
                    vs_currency: currency,
                    ids: "tron"
                }
            })

            setTRXData(trxPriceData.data[0])


        }

        fetchcoinDetails()
        checkUpdate()
        setIsLoading(false)

    }, [currency])

    const checkUpdate = () => {
        setInterval(() => {
            if (window.localStorage.getItem('CurrentCurrency')) {
                setCurrency(window.localStorage.getItem('CurrentCurrency'));
            }
        }, 1000)
    }

    const renderValuationComponent = () => {
        if (isLoading || trxData.length === 0) {
            return (<div>Loading....</div>)
        } else {
            if ((trxData.price_change_percentage_24h).toFixed(2) < 0) {
                trxPercent = <span className="trx-percent price-down">{(trxData.price_change_percentage_24h).toFixed(2)}<i className="fas fa-arrow-down"></i></span>
            } else {
                trxPercent = <span className="trx-percent price-up">+{(trxData.price_change_percentage_24h).toFixed(2)}<i className="fas fa-arrow-up"></i></span>
            }
            return (

                <div className="valuation-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-6 order-first order-md-last">
                                <TRXContent />
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="trx-details">
                                    <div className="trx-name">
                                        <img src={trxData.image} alt={"trx symbol"}></img>
                                        <span className="trx-name-span">TRX</span>
                                    </div>
                                    <div className="trx-price">
                                        {currency === 'inr' && trxData.current_price.toFixed(2) ? <em className="fas fa-rupee-sign"></em> : <span>$</span>}
                                        {trxData.current_price.toFixed(2)}
                                        {trxPercent}
                                    </div>
                                </div>
                                <TRXChart
                                    currency={currency}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            )

        }
    }




    return (
        <>
            {renderValuationComponent()}
        </>
    );
}

export default Valuation;